module.exports = __webpack_public_path__ + "static/media/windDirection.fe1c013b.svg";